import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const tabName = this._getTabNameFromHash()
    const index = tabName ? this._indexForName(tabName) : 0
    this.showTab(index >= 0 ? index : 0)

    this._onHashChange = this._handleHashChange.bind(this)
    window.addEventListener("hashchange", this._onHashChange)
  }

  disconnect() {
    if (this._onHashChange) {
      window.removeEventListener("hashchange", this._onHashChange)
    }
  }

  switch(event) {
    const index = parseInt(event.params.index, 10)
    this.showTab(index)
    const name = this.tabTargets[index]?.dataset.tabName
    if (name) {
      history.replaceState(null, "", `#${name}`)
    }
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("border-indigo-500", "text-indigo-600")
        tab.classList.remove("border-transparent", "text-gray-500", "hover:border-gray-300", "hover:text-gray-700")
      } else {
        tab.classList.remove("border-indigo-500", "text-indigo-600")
        tab.classList.add("border-transparent", "text-gray-500", "hover:border-gray-300", "hover:text-gray-700")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  _handleHashChange() {
    const tabName = this._getTabNameFromHash()
    if (tabName) {
      const index = this._indexForName(tabName)
      if (index >= 0) this.showTab(index)
    }
  }

  _getTabNameFromHash() {
    const hash = window.location.hash.slice(1)
    return hash.split("/")[0] || null
  }

  _indexForName(name) {
    return this.tabTargets.findIndex((tab) => tab.dataset.tabName === name)
  }
}
